import { marked } from "marked";

import { EMPTY_STRING } from "../../constants";

/**
 * Convert markdown/plain text into an HTML string.
 * Detects if HTML already exists to avoid double-parsing.
 */
export const formatTextToHtml = (text = EMPTY_STRING) => {
  if (!text) return EMPTY_STRING;

  const isHtml = /<\/?[a-z][\s\S]*>/i.test(text);
  return isHtml ? text : marked.parse(text);
};

/**
 * Convert markdown/plain text into an object for dangerouslySetInnerHTML.
 */
export const getFormattedHtml = (text = EMPTY_STRING) => ({
  __html: formatTextToHtml(text),
});
